export default __webpack_public_path__ + "media/images/features/yado/step_2_text-eb387b43ebb997d489e39798aef94778.png";